import React from 'react';
import Skeleton from '../../common/skeleton';
import { Row, Col, Card } from 'react-bootstrap';

const DocumentDetailSkeleton = () => (
  <>
    <Card className="skeleton-card">
      <Row className="mt-4">
        <Col className="form-group">
          <Skeleton count={1} width={100} className={'form-label'} />
          <Skeleton
            count={1}
            height={37}
            containerClassName={'form-control p-0 mt-1 line-height-none'}
          />
        </Col>
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton
            count={1}
            height={37}
            containerClassName={'form-control p-0 mt-1 line-height-none'}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton
            count={1}
            height={37}
            containerClassName={'form-control p-0 mt-1 line-height-none'}
          />
        </Col>
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton
            count={1}
            height={37}
            containerClassName={'form-control p-0 mt-1 line-height-none'}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col className="form-group" md={6} lg={6} sm={6}>
          <Skeleton count={1} height={50} className={'comments-skeleton'} />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col className="form-group">
          <Skeleton
            count={1}
            height={35}
            width={140}
            className={'comments-skeleton'}
          />
        </Col>
      </Row>

      <Row className="mt-3 mb-4">
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton
            count={1}
            height={80}
            className={'comments-skeleton mt-1'}
          />
        </Col>
      </Row>
    </Card>
  </>
);

export default DocumentDetailSkeleton;
